const items = [
  "Bar & Caffetterie",
  "Ristoranti & Trattorie",
  "Tavole Calde & Fast Food",
  "Supermercati & Minimarket",
  "Gastronomie & Rosticcerie",
  "Pizzerie da Asporto",
  "Pub & Wine Bar",
  "Vendita di Alimenti",
];

export default function Marquee() {
  return (
    <div className="overflow-hidden border-y border-line bg-white py-5" data-testid="activities-marquee">
      <div className="animate-marquee flex w-max items-center">
        {[...items, ...items].map((item, i) => (
          <span key={i} className="flex items-center">
            <span className="whitespace-nowrap px-8 font-heading text-xl font-semibold tracking-tight text-navy/80 sm:text-2xl">
              {item}
            </span>
            <span className="h-2 w-2 rotate-45 bg-brand-amber" />
          </span>
        ))}
      </div>
    </div>
  );
}
